import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-flag',
  templateUrl: './icon-flag.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFlagComponent {}
